/**
 * @file 新闻列表页Store
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import immer from 'immer';

import isNil from 'lodash/isNil';
import {SELECT_ALL_TAG} from './constant';
import {ICategoryItem, INewsItem, INewsModule, IRecommendItem, ITagItem} from './type';

import {
    fetchGetNewsList,
    fetchGetNewsRecommend
} from '../../api/pages/newsApi';
import {PaginationProps} from 'antd/es/pagination';

// 预请求
let preRequest: any = {};
if (window) {
    const serverRenderData = (window as any).serverRenderData;
    if (serverRenderData) {
        preRequest.fetchGetNewsList = Promise.resolve({body: serverRenderData});
    }
    else {
        preRequest.fetchGetNewsList = fetchGetNewsList(window.location.search.slice(1));
    }
    preRequest.fetchGetNewsRecommend = fetchGetNewsRecommend(window.location.search.slice(1));
}

const useNewsStore = () => {
    const [newsModule, setNewsModule] = useState<INewsModule>({
        id: 0,
        nSysKey: 1,
        nSysName: '',
        newsCat: []
    });
    const [currentTag, setCurrentTag] = useState<ITagItem>(SELECT_ALL_TAG);
    const [currentCategory, setCurrentCategory] = useState<ICategoryItem>({
        id: 0,
        catName: '',
        catKey: '',
        catIcon: '',
        sysId: 0,
        sysName: '',
        newsList: []
    });
    const [tagList, setTagList] = useState<ITagItem[]>([]);
    const [categoryList, setCategoryList] = useState<ICategoryItem[]>([]);
    const [newsList, setNewsList] = useState<INewsItem[]>([]);
    const [recommendList, setRecommendList] = useState<IRecommendItem[]>([]);
    const [pagination, setPagination] = useState<PaginationProps>({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetNewsList || fetchGetNewsList(window.location.search.slice(1));
            delete preRequest.fetchGetNewsList;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const theResult = res.body.result || {};
                const theData = theResult.data || {};
                const newsModule = theData.newsModule;
                const categoryList = theData.categoryList || [];
                const currentCategory = theData.currentCategory || categoryList[0] || {id: 0};
                const tagList: ITagItem[] = theData.tagList || [];
                const currentTag = theData.currentTag || {id: 0};
                const newsList = theData.newsList || [];

                const currentModuleId = newsModule.nSysKey || 1;
                const currentCategoryId = currentCategory.id;

                setNewsModule(prevState =>
                    immer(prevState, draft => {
                        draft.id = newsModule.id;
                        draft.nSysKey = newsModule.nSysKey;
                        draft.nSysName = newsModule.nSysName;
                        draft.newsCat = newsModule.newsCat;
                    })
                );

                setCurrentCategory(prevState =>
                    immer(prevState, draft => {
                        draft.id = currentCategory.id;
                        draft.catName = currentCategory.catName;
                        draft.catKey = currentCategory.catKey;
                        draft.catIcon = currentCategory.catIcon;
                        draft.sysId = currentCategory.sysId;
                        draft.sysName = currentCategory.sysName;
                        draft.newsList = currentCategory.newsList;
                    })
                );

                setCurrentTag(currentTag);

                setTagList([
                    {
                        ...SELECT_ALL_TAG,
                        link: `/support/news?module=${currentModuleId}&category=${currentCategoryId}`
                    },
                    ...tagList.map(tag => ({
                        ...tag,
                        link: `/support/news?module=${currentModuleId}&tag=${tag.id}`
                    }))
                ]);

                setCategoryList(categoryList);

                setNewsList(newsList);
                setPagination(prevState =>
                    immer(prevState, draft => {
                        if (!isNil(theResult.page)) {
                            draft.current = theResult.page;
                        }
                        if (!isNil(theResult.pageSize)) {
                            draft.pageSize = theResult.pageSize;
                        }
                        if (!isNil(theResult.totalCount)) {
                            draft.total = theResult.totalCount;
                        }
                    })
                );
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetNewsRecommend || fetchGetNewsRecommend(window.location.search.slice(1));
            delete preRequest.fetchGetNewsRecommend;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const theResult: any[] = res.body.result || {};
                setRecommendList(
                    theResult.map(item => ({
                        id: item.id,
                        title: item.title,
                        link: item.link
                    }))
                );
            }

        })();
    }, []);

    return {
        newsModule,
        currentTag,
        tagList,
        categoryList,
        currentCategory,
        newsList,
        recommendList,
        pagination,
    };
};

export default useNewsStore;
